import React from 'react';

import { NavLink } from 'react-router-dom';
import { footerNav, serviceAreas, site } from '../data/site';

export default function Footer() {
  return (
    <footer className="vm-footer">
      <div className="vm-footer__inner">
        <div>
          <p className="vm-footer__name">{site.name}</p>
          <p className="vm-footer__blurb">{site.blurb}</p>
          <p className="vm-footer__areas">
            Also covering {serviceAreas.join(', ')}.
          </p>
          <ul className="vm-footer__badges">
            <li className="vm-footer__badge">Fully insured</li>
            <li className="vm-footer__badge">DBS checked</li>
          </ul>
        </div>

        <div>
          <h2 className="vm-footer__heading" id="vm-footer-pages">
            Pages
          </h2>
          <nav className="vm-footer__links" aria-labelledby="vm-footer-pages">
            {footerNav.map((item) => (
              <NavLink key={item.to} to={item.to} exact={item.to === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div>
          <h2 className="vm-footer__heading">Contact</h2>
          <div className="vm-footer__links">
            <span>{site.owner}</span>
            <a href={site.phoneHref}>{site.phone}</a>
            <a href={site.emailHref}>{site.email}</a>
          </div>
          <div className="vm-footer__social">
            <a href="#">Facebook</a>
            <a href="#">Instagram</a>
          </div>
        </div>
      </div>

      <div className="vm-footer__legal">
        <p>{site.copyright}</p>
      </div>
    </footer>
  );
}
